var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "shoppingShareId" } },
    [
      _c(
        "div",
        {},
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "productShortNameForm",
              attrs: { inline: true, model: _vm.form, "label-width": "70px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "店铺名称", prop: "mallCode" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "50", placeholder: "请输入店铺名称" },
                    model: {
                      value: _vm.form.queryMallName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "queryMallName", $$v)
                      },
                      expression: "form.queryMallName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "btn-r", attrs: { label: "" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.searchProductList },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    { staticClass: "normal-btn", on: { click: _vm.resetForm } },
                    [
                      _c("i", {
                        staticClass: "el-icon-refresh-left y-fc-4C84FF",
                      }),
                      _vm._v("重置"),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "yto-table" },
        [
          _c(
            "el-alert",
            {
              staticClass: "alert",
              attrs: {
                title: "",
                type: "info",
                closable: false,
                "show-icon": "",
              },
            },
            [
              _c("span", [
                _vm._v(
                  "1、可以将店铺分享出去，他人可直接接收分享，不用再重复店铺授权的操作。"
                ),
              ]),
              _c("br"),
              _c("span", [
                _vm._v("2、接收分享后，他人可以查看编辑店铺数据，请谨慎操作！"),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "btn-group",
              staticStyle: {
                "text-align": "left",
                padding: "0px 0px 20px 0px",
                display: "flex",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "10px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.createShareIdFn },
                    },
                    [_vm._v("创建分享店铺码")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-left": "10px" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { height: "34px" },
                      attrs: { plain: "" },
                      on: { click: _vm.lookShareJc },
                    },
                    [_vm._v("查看教程")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData,
                "tooltip-effect": "light",
                border: "",
                "span-method": _vm.objectSpanMethod,
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "店铺名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("img", {
                          staticClass: "iconstyle",
                          attrs: {
                            src: require(`@/assets/images/ecommercepng/icon_dianpu_${scope.row.platformCode}.png`),
                            alt: "",
                          },
                        }),
                        _c("span", [_vm._v(_vm._s(scope.row.mallName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "modifyTime", label: "分享店铺码更新时间" },
              }),
              _c("el-table-column", {
                attrs: { "show-overflow-tooltip": "", label: "分享店铺码" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.joinCode))]),
                        _c("i", {
                          staticClass: "el-icon-document-copy",
                          attrs: { title: "复制" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.copyShareIdInfo(scope.row)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.updateShareId(scope.row)
                              },
                            },
                          },
                          [_vm._v("更新分享店铺码")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "y-fc-F35252",
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteShareId(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.page.pageNo,
              "page-sizes": [10, 50, 100],
              "page-size": _vm.page.limit,
              layout: "total, sizes, prev, pager, next",
              total: _vm.page.total,
            },
            on: {
              "size-change": _vm.limitChange,
              "current-change": _vm.pageChange,
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "pageNo", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "pageNo", $event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "创建分享店铺码",
            visible: _vm.importXlsDialog,
            width: "710px",
            center: "",
            "before-close": _vm.closeShare,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.importXlsDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "create-share-shoppingId" },
            [
              _c(
                "el-alert",
                {
                  staticClass: "alert",
                  attrs: {
                    title: "",
                    type: "info",
                    closable: false,
                    "show-icon": "",
                  },
                },
                [
                  _c("span", [
                    _vm._v("1、仅显示当前用户账户下授权正常的店铺。"),
                  ]),
                  _c("br"),
                  _c("span", [
                    _vm._v("2、通过他人分享的店铺，不支持再次分享。"),
                  ]),
                ]
              ),
              _c("div", { staticClass: "create-title" }, [
                _vm._v("请添加店铺："),
              ]),
              _c(
                "div",
                { staticClass: "checkbox-content" },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.checkList,
                        callback: function ($$v) {
                          _vm.checkList = $$v
                        },
                        expression: "checkList",
                      },
                    },
                    _vm._l(_vm.shoppingList, function (item) {
                      return _c(
                        "el-checkbox",
                        {
                          key: item.id,
                          staticClass: "checkbox-width",
                          attrs: { label: item },
                        },
                        [
                          _c("img", {
                            staticClass: "iconstyle",
                            attrs: {
                              src: require(`@/assets/images/ecommercepng/icon_dianpu_${item.paltformCode}.png`),
                              alt: "",
                            },
                          }),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: item.mallName,
                                placement: "top",
                              },
                            },
                            [
                              _c("span", { staticClass: "check-title" }, [
                                _vm._v(_vm._s(item.mallName)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "check-total" }, [
            _c("span", [
              _vm._v("已选" + _vm._s(_vm.checkList.length) + "个店铺"),
            ]),
            _c(
              "div",
              {
                staticClass: "check-right-margin",
                on: { click: (e) => _vm.selectFn(e) },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "selected-style",
                    attrs: { "data-type": "all" },
                  },
                  [_vm._v("全选")]
                ),
                _vm._v("|"),
                _c(
                  "span",
                  {
                    staticClass: "selected-style",
                    attrs: { "data-type": "allNo" },
                  },
                  [_vm._v("反选")]
                ),
                _vm._v("|"),
                _c(
                  "span",
                  {
                    staticClass: "selected-style",
                    attrs: { "data-type": "No" },
                  },
                  [_vm._v("清空")]
                ),
              ]
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { plain: "" }, on: { click: _vm.closeShare } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.shareShopCreateShopConfigFn },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.tipFlag,
            width: "710px",
            center: "",
            "before-close": _vm.closeTip,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.tipFlag = $event
            },
          },
        },
        [
          _c("div", { staticClass: "create-share-shoppingId-tip" }, [
            _c("div", { staticClass: "tip-content" }, [
              _vm._v(
                " 创建成功，请将下方分享店铺码复制分享给他人，在【客户管家电脑端->基础信息->电商平台店铺页面->点击接收他人店铺】即可关联。 "
              ),
            ]),
            _c("div", { staticClass: "tip-share-title" }, [
              _vm._v("分享店铺码："),
            ]),
            _c("div", { staticClass: "tip-share-code" }, [
              _vm._v(_vm._s(_vm.joinData)),
              _c("i", {
                staticClass: "el-icon-document-copy",
                attrs: { title: "复制" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.copyShareIdInfo({ joinCode: _vm.joinData })
                  },
                },
              }),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.closeTip } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.deleteFlag,
            width: "710px",
            center: "",
            "before-close": _vm.closeDel,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.deleteFlag = $event
            },
          },
        },
        [
          _c("div", { staticClass: "create-share-shoppingId-tip" }, [
            !_vm.deleteOrUpdateFlag && !_vm.noMobileFlag
              ? _c("div", { staticClass: "tip-content-delete" }, [
                  _vm._v(
                    " 更新后，原来的分享店铺码将失效，但是通过原来分享码获得授权的店铺不受影响。 "
                  ),
                ])
              : _vm._e(),
            _vm.deleteOrUpdateFlag && !_vm.noMobileFlag
              ? _c("div", { staticClass: "tip-content-delete" }, [
                  _vm._v(
                    " 删除后，分享店铺码将失效，原来通过该店铺码分享授权的电商店铺均将授权失效！ "
                  ),
                ])
              : _vm._e(),
            _vm.noMobileFlag
              ? _c("div", { staticClass: "tip-content-delete" }, [
                  _vm._v(
                    " 为了保障您的店铺数据安全，需要您通过手机号登录的方式登录客户管家用于店铺分享。 "
                  ),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              !_vm.noMobileFlag
                ? _c(
                    "el-button",
                    { attrs: { plain: "" }, on: { click: _vm.closeDel } },
                    [_vm._v("取 消")]
                  )
                : _vm._e(),
              _vm.deleteOrUpdateFlag && !_vm.noMobileFlag
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.DeleteFn } },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              !_vm.deleteOrUpdateFlag && !_vm.noMobileFlag
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.UpdateFn } },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.noMobileFlag
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.noMobileFn },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.noMobileFlag
                ? _c(
                    "el-button",
                    { attrs: { plain: "" }, on: { click: _vm.noMobileFnJc } },
                    [_vm._v("查看教程")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }